import searchSlugsByCollection from '../api/graphql/queries/searchSlugsByCollection';

export const transformOptions = (posts) => {
  if (!Array.isArray(posts)) return [];
  return posts.map(post => ({ label: post.slugName, value: post.slugName }));
};

export const transformSlugnamesToSelectOptions = (options) => {
  const { slugNames } = options;
  if (!Array.isArray(slugNames)) return [];
  return slugNames.map(slugName => ({ label: slugName, value: slugName }));
};

export const transformDataToSelectOptions = (options) => {
  if (!Array.isArray(options)) return ({ label: options, value: options });
  return options.map(option => ({ label: option, value: option }));
};

export const getSlugNamesByCollection = (name, value) => searchSlugsByCollection(value, name)
  .then(res => transformSlugnamesToSelectOptions(res)).catch(() => []);
